module.exports = __webpack_public_path__ + "img/slideVerify_04.f4f73fb8.png";